import React from 'react'
import i18n from 'live/services/i18n'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import { lollipopReducer } from './reducer'
import { withSuspenseWrapper } from '../../components/SuspenseWrapper'
import { LollipopEvent, LollipopState } from './types'

const widgetType = 'lollipop'

const LollipopWidget = reactWidgetWrapper<LollipopState, FlowMessage<LollipopEvent>, DefaultChartConfigs>(
    withSuspenseWrapper(React.lazy(() => import('./LollipopWidgetController'))),
    lollipopReducer,
    {
        mapConfigToProps(configs) {
            return {
                widget: configs.widget
            }
        }
    }
)

export const DEFAULT_CHART_CONFIG = {
    verticalEnabled: false,
    legendEnabled: true,
    legendRight: false,
    tooltipType: 'group',
    yAxis: [
        {
            color: '#999999',
            fields: [],
            label: '',
            max: 'auto',
            min: 'auto',
            position: 'left',
            tickInterval: 'auto'
        }
    ]
}

const policies = {
    defaultReducer: ' ',
    legends: true,
    layers: 1,
    allowHideTooltip: true
}

widgetService.register({
    type: widgetType,
    get name() {
        return 'Lollipop'
    },
    policies,
    config: DEFAULT_CHART_CONFIG,
    description: i18n(
        'A temporal lollipop is a way of representing some numerical value that occurs over time with a thin bar and a circle on top of it. The position of the bar will represent the timestamp of the event and its height represents its value.'
    ),
    impl: LollipopWidget
})
